var React = require('react');

function Domain (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.000419296 39.6004C-0.0995807 61.6004 17.7004 79.6004 39.6004 79.7004C61.6004 79.9004 79.6004 62.0004 79.7004 40.1004C79.8004 18.1004 62.0004 0.200419 40.1004 0.000419296C40.0004 0.000419296 39.9004 0.000419296 39.8004 0.000419296C18.0004 -0.0995807 0.100419 17.7004 0.000419296 39.6004Z","fill":"#0EA800","key":0}),React.createElement("path",{"d":"M64 31.8938L50.4761 23L39.9833 29.8619L29.5239 23L21.8959 27.9965V25.0985H16V56.6433H22.0958V35.025L29.5239 30.1617L36.9521 35.025V56.6433H43.0479V35.025L50.4761 30.1617L57.9042 35.0583V56.6766H64V31.8938Z","fill":"white","key":1})]);
}

Domain.defaultProps = {"viewBox":"0 0 80 80","fill":"none"};

module.exports = Domain;

Domain.default = Domain;
